import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import {
  createLayout,
  deleteLayout,
  renameLayout,
  changePage,
  createPage,
  savePage,
} from "../core/redux/api/pages";

import RemovePayloadDialog from "./RemoveDialog";

import List from "./List";
import Icon from "./Icons";
import { l, copyToPage } from "../functions";
import ModalDialog from "./ModalDialog";
import { ajaxUri } from "../consts/index";
import GKEvent from "../events";
import PageTemplates from "./PageTemplates";
import {
  updatePayloadHistory,
  setHistorying,
} from "../core/redux/api/payloads";
import state from "../state";

const mapStateToProps = (state) => {
  return {
    fetchedPages: state.rootReducer.fetchedPages || [],
    toCopy: state.rootReducer.toCopy || null,
    payload: state.rootReducer.currentPayload || {},
  };
};

class PayloadsList extends Component {
  constructor(props) {
    super(props);

    this.defaultState = {
      currentModal: null,
      removingPayload: null,
      modalDatas: {},
      payloadsNames: {},
      importingTemplate: null,
      importingTemplateId: null,
    };

    this.state = this.defaultState;

    this._savePayloadName = this._savePayloadName.bind(this);
    this._renamePayload = this._renamePayload.bind(this);
  }

  _renamePayload = (key, value) => {
    this.setState({
      ...this.state,
      payloadsNames: {
        ...this.state.payloadsNames,
        [key]: value,
      },
    });
  };

  _savePayloadName = (index, pageId, name) => {
    this.props.renameLayout(pageId, name, () => {
      delete this.state.payloadsNames[pageId];
    });
  };

  _loadModal = (modal) => {
    axios({
      method: "post",
      url: ajaxUri,
      data: {
        request: "getPageSettings",
        pageid: modal,
      },
    })
      .then((result) => {
        if (result.data.status === "success")
          this.setState({ currentModal: modal, modalDatas: result.data.datas });
        else GKEvent.notification(result.data.status, result.data.message);
      })
      .catch((error) => {
        GKEvent.notification(
          "error",
          l("Error while loading the modal settings. Please try again.")
        );
      });
  };

  _saveModal = (modal, modalDatas) => {
    this.props.createPage(modalDatas, modal, () => {
      this.setState(this.defaultState);
    });
  };

  _saveLayout = (datas) => {
    this.props.setHistorying(true);
    this.props.updatePayloadHistory(JSON.parse(datas.payload));
    this.props.savePage(false);
  };

  render() {
    let payloadsCount = 0;

    this.props.fetchedPages.forEach((payload) => {
      if (payload.tab === this.props.target) payloadsCount = payloadsCount + 1;
    });

    return (
      <div>
        <RemovePayloadDialog
          open={this.state.removingPayload}
          onConfirm={() => {
            this.props.deleteLayout(
              this.state.removingPayload,
              this.setState(this.defaultState)
            );
          }}
          onClose={() => {
            this.setState(this.defaultState);
          }}
          title={`${l("You are deleting a")} ${this.props.target} ${l(
            "layout ?"
          )}`}
        />

        {this.state.importingTemplate && (
          <PageTemplates
            target={this.state.importingTemplate}
            targetId={this.state.importingTemplateId}
            onSubmit={(datas, cb = () => {}) => {
              this._saveLayout(datas);
              cb();
            }}
            onClose={() => this.setState(this.defaultState)}
          />
        )}

        {this.props.target === "modal" && (
          <ModalDialog
            open={this.state.currentModal ? true : false}
            datas={this.state.modalDatas}
            onSubmit={(datas) =>
              this._saveModal(this.state.currentModal, datas)
            }
            onClose={() => this.setState(this.defaultState)}
          />
        )}
        {this.props.toCopy === null && (
          <button
            className="new-item"
            onClick={() => {
              this.props.createLayout(
                this.props.target,
                this.setState(this.defaultState)
              );
            }}
          >
            <Icon icon="plus" />
          </button>
        )}
        {this.props.fetchedPages.map((payload, index) => {
          const layoutName =
            this.state.payloadsNames[payload.key] !== undefined
              ? this.state.payloadsNames[payload.key]
              : payload.name;

          let actions = [];

          if (payloadsCount > 1 || this.props.target === "modal")
            actions.push({
              label: l("Delete") + " " + this.props.target + " " + l("layout"),
              action: () => {
                this.setState({ removingPayload: payload.key });
              },
            });

          if (
            this.props.target == "product" &&
            this.props.currentPage === payload.key &&
            payload.layouts
          ) {
            actions.push({
              label: l("Clon product layout"),
              action: () => {
                const layoutData = state.getStorableState();
                const layoutKey = payload?.key;
                this.props.createLayout(
                  this.props.target,
                  this.setState(this.defaultState),
                  true
                );
              },
            });
          }
          if (this.props.target === "modal")
            actions.push({
              label: l("Edit") + " " + this.props.target,
              action: () => this._loadModal(payload.key),
            });

          if (this.props.currentPage === payload.key && payload.layouts)
            actions.push({
              label: l("Use template"),
              action: () => {
                this.setState({
                  importingTemplate: payload.layouts,
                  importingTemplateId: payload.key,
                });
              },
            });

          if (payload.tab === this.props.target)
            return (
              <List
                key={payload.key}
                itemKey={payload.key}
                active={this.props.currentPage === payload.key}
                index={index}
                rename={{
                  label: l("Rename"),
                  onChange: this._renamePayload,
                  onSave: this._savePayloadName,
                }}
                draggable={false}
                content={[layoutName, "ID : " + payload.key]}
                actions={actions}
                onClick={() => {
                  if (this.props.toCopy)
                    copyToPage(payload.key, this.props.toCopy);
                  else this.props.changePage(payload.key);
                }}
                warning={payload.missing_element ? l("Missing elements !") : ""}
                readOnly={this.props.toCopy ? true : false}
              />
            );
        })}
      </div>
    );
  }
}

export default connect(mapStateToProps, {
  createLayout,
  deleteLayout,
  renameLayout,
  changePage,
  createPage,
  updatePayloadHistory,
  setHistorying,
  savePage,
})(PayloadsList);
